export default __webpack_public_path__ + "/dist/images/2450674.png";